import React from 'react';

/**
 * HowToIcons
 * ─────────────────────────────────────────────────────────────────
 * Four small inline SVG icons used to break up the "How to use"
 * slide-in panels across the four gurus. lucide-react is not
 * installed in this project so we keep these as bespoke 24x24
 * stroke-based SVGs rather than introducing a dependency.
 *
 * Icons take a single `colour` prop so they can adopt each guru's
 * brand colour at the call site.
 *
 *   PurposeIcon   — for the "What it's for" section (target)
 *   FlowIcon      — for "How it works" (right arrow)
 *   OutcomeIcon   — for "What you will get" (check inside circle)
 *   TipsIcon      — for "Tips" (lightbulb)
 */

const baseProps = (colour) => ({
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: colour,
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
});

export function PurposeIcon({ colour = '#1a1a2e' }) {
  return (
    <svg {...baseProps(colour)}>
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="6" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  );
}

export function FlowIcon({ colour = '#1a1a2e' }) {
  return (
    <svg {...baseProps(colour)}>
      <line x1="4" y1="12" x2="20" y2="12" />
      <polyline points="13 5 20 12 13 19" />
    </svg>
  );
}

export function OutcomeIcon({ colour = '#1a1a2e' }) {
  return (
    <svg {...baseProps(colour)}>
      <circle cx="12" cy="12" r="10" />
      <polyline points="8 12 11 15 16 9" />
    </svg>
  );
}

export function TipsIcon({ colour = '#1a1a2e' }) {
  return (
    <svg {...baseProps(colour)}>
      <path d="M9 18h6" />
      <path d="M10 22h4" />
      <path d="M12 2a7 7 0 0 0-4 12.7c.7.5 1 1.3 1 2.3v1h6v-1c0-1 .3-1.8 1-2.3A7 7 0 0 0 12 2z" />
    </svg>
  );
}
